import { Button } from 'ui/Button';
import styles from './ActionRequiredAlert.module.scss';
import { ReactComponent as IconAlert } from './img/iconAlert2.svg';
import { ReactComponent as IconClose } from './img/iconClose.svg';
import { useState } from 'react';

export const ActionRequiredAlert = ({
  tab,
  onClick,
  title,
  subtitle,
}: {
  tab: string;
  onClick: () => void;
  title: string;
  subtitle: string;
}) => {
  const [hidden, setHidden] = useState(false);

  if (hidden) return null;
  if (hidden) return null;
  if (tab === 'customer-action-required' && title === 'Заказы требующие действия')
    return null;
  if (tab === 'approving_volume' && title === 'Подтверждение объема') return null;
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.header_left}>
          <IconAlert />
          <div className={styles.header_text}>
            <span className={styles.header_title}>{title}</span>
            <div className={styles.body}>
              <span>{subtitle}</span>
            </div>
          </div>
        </div>
        <div className={styles.header_right}>
          <Button className={styles.btn} onClick={onClick} theme='filed'>
            Перейти
          </Button>
          <IconClose style={{ cursor: 'pointer' }} onClick={() => setHidden(true)} />
        </div>
      </div>
    </div>
  );
};
